import { render } from "./OrderTracking.vue?vue&type=template&id=4c229f34"
import script from "./OrderTracking.vue?vue&type=script&lang=js"
export * from "./OrderTracking.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__